var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "pm-template-list-item" }, [
    _c(
      "div",
      { staticClass: "box-bubble" },
      [
        _c(_setup.PMTemplateListItemForm, {
          attrs: { "edit-id": _setup.editId },
          on: {
            "on-success": _setup.onSuccessHandler,
            "on-cancel": _setup.onCancelHandler
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "box-bubble index" },
      [
        _c(_setup.PMTemplateListItemIndex, {
          ref: "pmTemplateListItemIndexRef",
          on: { "on-edit": _setup.onEditHandler }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }